module.exports = __webpack_public_path__ + "img/banner.21cad1fa.png";